var map = {
	"./1.jpeg": "da36",
	"./2017博览会.jpg": "b484",
	"./address.png": "c542",
	"./banner.png": "d22d",
	"./email.png": "8608",
	"./logo.png": "4ffd",
	"./mark_bs.png": "786c",
	"./mobile.png": "a74c",
	"./productbg.png": "39d2",
	"./qrcode.jpg": "963e",
	"./云数据.png": "569d",
	"./产品中心.png": "6a91",
	"./产品展示.png": "60d9",
	"./产品自定义.png": "efad",
	"./企业荣誉.png": "453c",
	"./关于我们.png": "2b43",
	"./四诊仪.png": "eadd",
	"./大厦.png": "1734",
	"./大楼.png": "6b7d",
	"./康复展.jpg": "1dcb",
	"./新闻图片1.png": "1885",
	"./新闻图片2.png": "facb",
	"./检测报告.png": "c71c",
	"./治未病.jpg": "98f0",
	"./白箭头.png": "e664",
	"./知网.jpg": "4391",
	"./研发力量.png": "7187",
	"./社区版.jpg": "ad71",
	"./秋季博览会.jpg": "5deb",
	"./脉诊仪.jpg": "a56f",
	"./黑箭头.png": "64b2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb6e";